/*
  Malpetit · Wishlist — localStorage based, no app, no login.
  - Heart buttons [data-mp-wish][data-handle] toggle a product in the wishlist.
  - Wishlist page: [data-mp-wishlist-grid] holds [data-wishlist-item][data-handle]
    children (all hidden); this script reveals saved ones, toggles empty state.
  Loaded once globally (layout/theme.liquid).
*/
(function () {
  'use strict';
  var KEY = 'mp_wishlist';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }

  function syncHearts() {
    var list = read();
    document.querySelectorAll('[data-mp-wish][data-handle]').forEach(function (btn) {
      var on = list.indexOf(btn.getAttribute('data-handle')) !== -1;
      btn.classList.toggle('is-on', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function syncCount() {
    var n = read().length;
    document.querySelectorAll('[data-mp-wish-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }

  function renderWishlistPage() {
    var grid = document.querySelector('[data-mp-wishlist-grid]');
    var empty = document.querySelector('[data-mp-wishlist-empty]');
    if (!grid && !empty) return;
    var list = read();
    var shown = 0;
    if (grid) {
      grid.querySelectorAll('[data-wishlist-item]').forEach(function (item) {
        var on = list.indexOf(item.getAttribute('data-handle')) !== -1;
        item.hidden = !on;
        if (on) shown++;
      });
      grid.hidden = shown === 0;
    }
    if (empty) empty.hidden = shown > 0;
    var countEl = document.querySelector('[data-mp-wishlist-count]');
    if (countEl) countEl.textContent = shown;
    var countLine = document.querySelector('[data-mp-wishlist-countline]');
    if (countLine) countLine.hidden = shown === 0;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mp-wish][data-handle]');
    if (!btn) return;
    e.preventDefault();
    var handle = btn.getAttribute('data-handle');
    if (!handle) return;
    var list = read();
    var i = list.indexOf(handle);
    if (i === -1) { list.push(handle); } else { list.splice(i, 1); }
    write(list);
    syncHearts();
    syncCount();
    renderWishlistPage();
  });

  function init() {
    syncHearts();
    syncCount();
    renderWishlistPage();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
